import script from "./PlayersComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayersComponent.vue?vue&type=script&setup=true&lang=js"

import "./PlayersComponent.vue?vue&type=style&index=0&id=2d118608&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d118608"]])

export default __exports__